import { useEffect, useState } from "react";
import api from "@/lib/api";
import Layout from "@/components/Layout";
import StoreCard from "@/components/StoreCard";
import { useLang } from "@/contexts/LangContext";

export default function Stores() {
    const { t } = useLang();
    const [stores, setStores] = useState([]);
    useEffect(() => {
        api.get("/stores").then((r) => setStores(r.data));
    }, []);
    return (
        <Layout>
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
                <h1 className="text-3xl md:text-4xl font-black text-espresso">{t("stores")}</h1>
                <div className="grid md:grid-cols-3 gap-6 mt-8" data-testid="stores-grid">
                    {stores.map((s) => <StoreCard key={s.store_id} store={s} />)}
                </div>
            </div>
        </Layout>
    );
}
